import { render, staticRenderFns } from "./merchant-balance-settlement.vue?vue&type=template&id=49d1f014&"
import script from "./merchant-balance-settlement.vue?vue&type=script&lang=js&"
export * from "./merchant-balance-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports